import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Layout from '../../../components/layout/AppLayout';
import Header from '../../../../shared/components/layout/Header';
import { useSidebar } from '../../../../shared/contexts/SidebarContext';
import MyTask from './MyTask';
import TaskTemplate from './TaskTemplate';
import ConfigureHoliday from './ConfigureHoliday';

const tabs = [
  { key: 'task', label: 'Task' },
  { key: 'taskTemplate', label: 'Task Template' },
  { key: 'configureHoliday', label: 'Configure Holiday' }
];

const TaskManagement = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || 'task');
  const { collapsed } = useSidebar();

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state?.activeTab]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'task':
        return <MyTask />;
      case 'taskTemplate':
        return <TaskTemplate />;
      case 'configureHoliday':
        return <ConfigureHoliday />;
      default:
        return <MyTask />;
    }
  };



  return (
    <Layout>
      <div
        className={`fixed z-[10] top-0 border-b border-gray-200 shadow-sm transition-all duration-300 ease-in-out ${
          collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
        }`}>
        <Header backArrow={false}>
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-4 py-1.5 rounded-[8px] text-sm font-medium border transition-all duration-200 ${
                activeTab === tab.key
                  ? 'bg-[#2A565E] text-white border-[#2A565E]'
                  : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'
              }`}>
              {tab.label}
            </button>
          ))}
        </Header>
      </div>

      <div style={{ marginTop: '4.1rem' }}>
        {renderTabContent()}
      </div>
    </Layout>
  );
};

export default TaskManagement;
